import React, { useEffect } from "react";
import Header from "../components/Header";
import { FaCheckCircle } from "react-icons/fa";

const SubmissionSuccess = () => {
  useEffect(() => {
    // Redirect to the homepage after 5 seconds
    const timer = setTimeout(() => {
      window.location.href = "/";
    }, 10000);
    // Cleanup the timer if the component unmounts before the timer is complete
    return () => clearTimeout(timer);
  }, []);

  const handleBackToHomepage = () => {
    window.location.href = "/";
  };

  return (
    <div>
      {/* Header */}
      <Header />
      <div className="min-h-screen bg-gray-100">
        {/* Success Message Box */}
        <div className="flex justify-center items-center min-h-[80vh] sticky top-[5rem] z-40">
          <div className="bg-white p-8 rounded-lg shadow-lg text-center max-w-4xl w-full h-[550px]">
            {/* Green Tick Icon */}
            <FaCheckCircle className="text-green-700 text-6xl mt-10 mx-auto mb-8 h-24" />

            {/* Success Message */}
            <h2 className="text-2xl font-semibold mb-4">
              Your Application has been submitted successfully
            </h2>
            <p className="text-gray-600 mb-6">
              A confirmation will be sent to your email shortly.
            </p>

            {/* Back to Homepage Button */}
            <button
              className="bg-green-700 text-white px-6 py-3 rounded-lg hover:bg-green-700 transition-all mt-14"
              onClick={handleBackToHomepage}
            >
              Back to EAC Homepage
            </button>

            <p className="text-sm text-gray-500 mt-4">
              You will be redirected to the homepage in 10 seconds.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubmissionSuccess;
